import type { EvolutionPrintableCategory } from '../components/evolution/evolutionWorkflowTypes';

/** Telas ocultas quando a unidade está em especialidade fisioterapia (menu mais enxuto). */
export const FISIOTERAPIA_HIDDEN_CLINIC_PATHS: readonly string[] = [
  '/clinic/prescriptions',
  '/clinic/exam-orders',
  '/clinic/laboratory',
  '/clinic/certificates',
];

/** Categorias do assistente de impressos da evolução que não se aplicam à fisioterapia. */
export const FISIOTERAPIA_HIDDEN_EVOLUTION_PRINTABLE_CATEGORIES: ReadonlySet<EvolutionPrintableCategory> =
  new Set<EvolutionPrintableCategory>(['prescription']);

export function filterEvolutionPrintableCategoriesForSpecialty<T extends { key: EvolutionPrintableCategory }>(
  categories: readonly T[],
  specialty: string | null,
): T[] {
  let out = specialty === 'oftalmologia'
    ? [...categories]
    : categories.filter((c) => c.key !== 'refraction');
  if (specialty === 'fisioterapia') {
    out = out.filter((c) => !FISIOTERAPIA_HIDDEN_EVOLUTION_PRINTABLE_CATEGORIES.has(c.key));
  }
  return out;
}

export function defaultEvolutionPrintableCategoryForSpecialty(
  specialty: string | null,
): EvolutionPrintableCategory {
  const visible = filterEvolutionPrintableCategoriesForSpecialty(
    [
      { key: 'prescription' as EvolutionPrintableCategory },
      { key: 'certificate' as EvolutionPrintableCategory },
      { key: 'medical_report' as EvolutionPrintableCategory },
    ],
    specialty,
  );
  return visible[0]?.key ?? 'report';
}

export function isFisioterapiaHiddenClinicPath(path: string): boolean {
  const normalized = (path.split('?')[0] || '').replace(/\/$/, '') || '/';
  return FISIOTERAPIA_HIDDEN_CLINIC_PATHS.some(
    (p) => normalized === p || normalized.startsWith(`${p}/`),
  );
}
